module.exports = __webpack_public_path__ + "static/media/660000.6f676cee.png";